import React from 'react';
import { FormattedMessage } from 'react-intl';

export function workerTable(tableTitle, workers, columnDefinition, headings, sort, sortColumn, sortDesc, noneMessage) {
    return (
        <div className="card">
            <div className="card-title">
                <FormattedMessage {...tableTitle} /> {` (${workers.length})`}
            </div>
            {workers.length > 0 ? (
                <React.Fragment>
                    <div className="tab-items-heading">
                        {headings.map((h, i) => (
                            <div className={`${h.size} ${h.sort ? 'clickable' : ''}`} onClick={() => sort(h.sort, i)} key={i}>
                                {h.text}
                                <div className="pull-right">{renderSortIcon(h.sort, i, sortColumn, sortDesc)}</div>
                            </div>
                        ))}
                    </div>
                    <ul className="tab-items-list">{workers.map((worker, i) => <li key={i}>{columnDefinition(worker)}</li>)}</ul>
                </React.Fragment>
            ) : (
                <div className="row">
                    <div className="col-xs-12">
                        <div className="col-xs-12 no-onboarding-workers">{noneMessage}</div>
                    </div>
                </div>
            )}
        </div>
    );
}

export function workerLink(employment, history, tab) {
    history.push(`/worker/${employment.client_id}/${employment.contractor.id}/${employment.user.id}/${tab || 0}`);
}

function renderSortIcon(comparer, columnIndex, sortColumn, sortDesc) {
    if (!comparer) {
        return null;
    }

    if (columnIndex !== sortColumn) {
        return <i className="material-icons">unfold_more</i>;
    }

    return <i className="material-icons"> {sortDesc ? 'expand_less' : 'expand_more'} </i>;
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/components/workers/_common.jsx